var path = 'areas/master/getting-started/views/getting_started_dialog.html';
var html = "<button class=\"getting-started-dialog-close close\" type=button data-dismiss=modal aria-hidden=true ng-click=close()>×</button> <div class=\"modal-body getting-started-dialog-body\"> <getting-started-detail></getting-started-detail> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/master/getting-started/views/getting_started_dialog.html
// module id = 8347750417770248
// module chunks = 1